export //将时间戳进行转换日期显示，如年月日时分秒
function dateFormat (date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
        }
    }
    return fmt
}
  
export 
function padLeftZero (str) {
    return ('00' + str).substr(str.length)
}

export //将时间戳进行转换，用分，时，天作为单位来表示，超过7天的用日期显示
function timeFormat(dateTimeStamp){
    let minute=1000*60;      //把分，时，天，周，半个月，一个月用毫秒表示  
    let hour=minute*60;  
    let day=hour*24;  
    let week=day*7;  
    let halfamonth=day*15;  
    let month=day*30;  

    let  now=new Date().getTime();   //获取当前时间毫秒  
    let diffValue=now - dateTimeStamp;//时间差

    if(diffValue<0){
        return;
    }     

    let  minC=diffValue / minute;  //计算时间差的分，时，天，周，月  
    let  hourC=diffValue / hour;  
    let  dayC=diffValue / day;  
    let  weekC=diffValue / week; 
    let  result = "结果有异常";

    if(weekC<1){
        if(dayC>=1){  
            result=""+ parseInt(dayC) +"天前";  
        }  
        else if(hourC>=1){  
            result=""+ parseInt(hourC) +"小时前";  
        }  
        else if(minC>=1){  
            result=""+ parseInt(minC) +"分钟前";  
        }else{
            result="刚刚";
        }
        return result;
    }else if(weekC>=1){
        let date = new Date(dateTimeStamp);
        return dateFormat(date,'yyyy-MM-dd');
    }

      

}
  


// WEBPACK FOOTER //
// ./src/common/js/dateTimeFormat.js